import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { graphierQLNextClient } from "utils";

import {
	CreateMapMutation,
	CreateMapMutationVariables,
} from "~maps-portal/types/__generated/gql/graphql";

const query = /* GraphQL */ `
	mutation CreateMap($input: CreateMapInput!) {
		createMap(input: $input) {
			id
			name
			description
		}
	}
`;

export type CreateMapResults = CreateMapMutation["createMap"];
export type CreateMapVariables = CreateMapMutationVariables;

export const useCreateMap = (): UseMutationResult<
	CreateMapResults,
	Error,
	CreateMapVariables
> => {
	return useMutation({
		mutationKey: ["CreateMap"],
		mutationFn: (variables: CreateMapVariables) =>
			graphierQLNextClient<CreateMapMutation, CreateMapVariables>({
				query,
				variables,
			}).then((res) => res.createMap),
	});
};
